<template>
  <div class="grid-x grid-margin-x">
    <div v-if="isMobile" class="cell title-mobile padding-bottom-xs">
      <ProductEngagementMcom v-if="bestSeller" class="hide-for-medium" is-best-seller />
      <ProductTitle />
      <MarketPlaceTitle v-if="isMcomMarketPlace" />
    </div>
    <div class="relative" :class="cellLeft">
      <Media />
      <ProductEngagementMcom v-if="productHasEngagementPill" is-pill />
    </div>
    <div :class="cellRight">
      <div v-if="!isMobile" class="title">
        <ProductEngagementMcom v-if="bestSeller" class="show-for-medium" is-best-seller />
        <ProductTitle />
        <MarketPlaceTitle v-if="isMcomMarketPlace" />
        <ReviewRating />
      </div>
      <ProductTraits>
        <template #shop-more>
          <ShopMoreFacade v-if="isMcom && isShopMoreStandardEnabled" />
        </template>
      </ProductTraits>

      <GWPFacade v-if="isGwpPhase1" data-testid="gwp-facade" />

      <CTAButtons v-if="callToActionButtons" :class="[productHasEngagementPill ? 'margin-bottom-m medium-margin-bottom-z' : 'margin-bottom-m']" />

      <template v-if="isBcom">
        <div v-if="isWhiteGloveDelivery" class="white-glove-delivery margin-bottom-xs">
          <p class="label margin-bottom-xxs">WHITE GLOVE DELIVERY</p>
          <div>
            <p class="small">Delivery will be scheduled at checkout.</p>
          </div>
        </div>
        <TransitionExpand
          :should-render-content="shouldRenderAvailability"
          :is-animated="killswitches.isDnFExpandAnimated"
          class="margin-bottom-m"
          data-testid="availability"
        >
          <Availability />
        </TransitionExpand>
        <AvailabilityBigTicket v-if="isBigTicketItemFlag" class="margin-bottom-s" />
        <GWPFacade v-if="!isMobile && !isPerksBelowZoneA && isGwpPhase2" data-testid="gwp-facade" />
        <OnDisplay v-if="isBigTicketItemFlag && killswitches.isBcomBigTicketSeeItInStoreEnabled" />

        <div
          v-if="isBigTicketItemFlag || isFineJewelryCategory"
          class="margin-top-s margin-bottom-m"
          v-html="isBigTicketItemFlag ? callCenterCTAMessage : messages.callCenterJewelryMessage"
        ></div>
      </template>

      <ProductEngagementMcom v-if="productHasEngagementPill" class="show-for-medium" />

      <template v-if="isMcom">
        <TransitionExpand
          :should-render-content="shouldRenderAvailability"
          :is-animated="killswitches.isDnFExpandAnimated"
          class="margin-bottom-m"
          data-testid="availability"
        >
          <Availability />
        </TransitionExpand>
        <AvailabilityBigTicket v-if="isBigTicketItemFlag" class="margin-top-m margin-bottom-m" />
        <GWPFacade v-if="!isMobile && !isPerksBelowZoneA && isGwpPhase2" data-testid="gwp-facade" />
        <OnDisplay v-if="isBigTicketItemFlag && killswitches.isMcomBigTicketSeeItInStoreEnabled" />
      </template>

      <BTZipCodeSlideout v-if="isBigTicketItemFlag" />

      <template v-if="isPerksAboveZoneA && !isMobile">
        <LoyaltyPerksFacade class="cell margin-bottom-m" data-testid="loyalty-perks-section-treatment-1" />
        <ProductPerks data-testid="perks-section-above-pros" />
      </template>

      <div v-if="isPerksBelowZoneA && !isMobile" class="margin-top-m">
        <GWPFacade v-if="isGwpPhase2" class="margin-bottom-m" data-testid="gwp-facade" />
        <LoyaltyPerksFacade class="cell margin-bottom-m" data-testid="loyalty-perks-section-treatment-2" />
        <ProductPerks data-testid="perks-section-below-pros" />
      </div>

      <LazyLoadWhenInViewport>
        <SponsoredItemTop
          v-if="showSponsoredItemTop"
          :enable-click-tags-for-s-m-products="killswitches.enableClickTagsForSMProducts"
          :is-simplification-mcom-on="killswitches.priceSimplificationEnabled"
        />
      </LazyLoadWhenInViewport>
    </div>
    <template v-if="isBcom">
      <ProsZoneAVertical v-if="!isMobile" data-testid="pros-section" class="cell large-12 margin-top-xl" />
    </template>
    <div class="cell large-12" data-testid="product-details-section">
      <ProductDetails :class="{ 'margin-top-xl': !isMobile && !showSponsoredItemTop }" />
    </div>
    <template v-if="isMcom">
      <ProsZoneAVertical v-if="!isMobile" data-testid="pros-section" class="cell large-12 margin-top-m" />
    </template>
    <div v-if="isPerksAboveZoneA && isMobile" class="cell margin-top-m">
      <GWPFacade v-if="isGwpPhase2" class="cell margin-bottom-m" data-testid="gwp-facade" />
      <LoyaltyPerksFacade class="cell margin-bottom-m" data-testid="loyalty-perks-section-treatment-1" />
      <ProductPerks class="cell" data-testid="perks-section-above-pros-mobile" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import SponsoredItemTop from '@nuxt-common/site-monetization/app/components/SponsoredItemTop';
import LoyaltyPerksFacade from '~/modules/productPerks/components/LoyaltyPerksFacade';
import ProductTitle from '~/components/productTitle/ProductTitle.common.vue';
import ProductTraits from '~/components/ProductCard/ProductTraits';
import ReviewRating from '~/modules/reviews/components/ReviewRating';
import Media from '~/components/common/Media/Media';
import OnDisplay from '~/components/common/OnDisplay';
import CTAButtons from '~/components/ctaButtons/CTAButtons';
import MarketPlaceTitle from '~/components/marketPlace/MarketPlaceTitle';
import ProductEngagementMcom from '~/components/ProductEngagement.mcom';
import LazyLoadWhenInViewport from '~/components/common/LazyLoadWhenInViewport';
import ProsZoneAVertical from '~/modules/pros/ProsZoneAVertical';
import StaticImportProductDetails from '~/modules/productDetails/components/ProductDetails';
import LazyHydratedProductDetails from '~/modules/lazy-hydration/components/ProductDetails';
import { useAvailabilityBigTicket } from '~/modules/availability/composables/useAvailabilityBigTicket';
import ProductPerks from '~/modules/productPerks/components/ProductPerks';
import TransitionExpand from '~/components/common/TransitionExpand';
import GWPFacade from '~/modules/gwp/components/GWPFacade';
import { useProductPrice } from '~/modules/price/composables/useProductPrice';
import Availability from '~/modules/availability/components/AvailabilityView';
import AvailabilityBigTicket from '~/modules/availability/components/AvailabilityBigTicket';
import BTZipCodeSlideout from '~/modules/availability/components/slideouts/BTZipCodeSlideout';
import { useAvailability } from '~/modules/availability/composables/useAvailability';
import useGetItTodayExperiments from '~/modules/availability/composables/useGetItTodayExperiments';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import { useDivisionCategoryFlags } from '~/modules/featureControl/composables/useDivisionCategoryFlags';
import { useBrand } from '~/composables/useBrand';
import { useDeviceType } from '~/composables/utils/useDeviceType';
import useExperiments from '~/stores/useExperimentsStore';
import ShopMoreFacade from '~/modules/shop-more/components/ShopMoreFacade';
import useGridLayoutConfig from '~/composables/useGridLayoutConfig';

import messages from '~/constants/messages';

const selectedPrice = useProductPrice();
const { killswitches } = useKillswitches();

let ProductDetails = StaticImportProductDetails;

// TODO: remove later once lazy hydration testing is over
if (killswitches.isLazyHydrationEnabled) {
  ProductDetails = LazyHydratedProductDetails;
}

const { isAvailabilityEnabled } = useAvailability();
const { shouldRenderAvailability } = useGetItTodayExperiments(isAvailabilityEnabled);
const { isBigTicketItemFlag } = useProductFlags();
const {
  callToActionButtons,
  showSponsoredItemTop,
  marketPlaceItemEnabled,
  productHasEngagementPill,
  bestSeller,
  basePerksConditions,
  isProductPerksEnabled,
  isProductPerksEnabledPhase2,
} = useFeatureEligibility();

const { isMcom, isBcom } = useBrand();
const { isMobile } = useDeviceType();
const { isWhiteGloveDelivery, callCenterCTAMessage } = useAvailabilityBigTicket();

const {
  experimentFlags: {
    isShopMoreStandardEnabled,
    isSplitPerksEnabled,
    isSplitPerksV2Enabled,
    isSplitPerksV2EnabledSignedIn,
    isGWPEnabled,
    isGWPEnabled2,
  },
} = useExperiments();
const { isFineJewelryCategory } = useDivisionCategoryFlags();

const isMcomMarketPlace = isMcom && marketPlaceItemEnabled;

const { cellLeft, cellRight } = useGridLayoutConfig();

const isPerksAboveZoneAPhase1 = isProductPerksEnabled && isMcom && !isProductPerksEnabledPhase2;
const isPerksAboveZoneAPhase2 = isSplitPerksEnabled && !isSplitPerksV2Enabled && !isSplitPerksV2EnabledSignedIn;

const isPerksAboveZoneA = basePerksConditions && (isPerksAboveZoneAPhase1 || isPerksAboveZoneAPhase2);

const isPerksBelowZoneAPhase1 = isProductPerksEnabled && isBcom && !isProductPerksEnabledPhase2;
const isPerksBelowZoneAPhase2 = (isSplitPerksV2Enabled || isSplitPerksV2EnabledSignedIn) && !isSplitPerksEnabled;
const isPerksBelowZoneA = basePerksConditions && (isPerksBelowZoneAPhase1 || isPerksBelowZoneAPhase2);

const isGwpPhase1 = computed(() => isGWPEnabled && !isGWPEnabled2 && selectedPrice.value.isGWPAvailable);
const isGwpPhase2 = computed(() => !isGWPEnabled && isGWPEnabled2 && selectedPrice.value.isGWPAvailable);
</script>

<style lang="scss" scoped>
@import '~settingSCSS';
@include title;
</style>
